<template>
    <div>
      <!-- Start Breadcrump Area  -->
      <N2CabezaPagina v-if="disenoPropio" titulo="Accesibilidad" />
      <div v-else
        class="rn-page-title-area pt--120 pb--190 banner-service-details-notin"
        data-black-overlay="5"
      >
        <v-container>
          <v-row>
            <v-col cols="12">
              <div class="rn-page-title text-center pt--100 ">
                <h1 class="headingtitle">Accesibilidad</h1>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <!-- End Breadcrump Area  -->
  
      <div class="rn-service-details rn-section-gap bg_color--1 content-service-details-notin">
        <v-container>
          <v-row>
            <v-col lg="12">
              <div class="inner">
                <!-- Start Single Content  -->
                <v-row
                  class="pb--80 align-items-center text-justify"
                >
                  <v-col lg="12" md="12" cols="12">
                    <div class="contentlegal space-y-6">
                      <div v-if="NOTARIA.AccessibilityPage" v-html="htmlLegal(NOTARIA.AccessibilityPage)" class="prose max-w-none">
                      </div>
                      <div v-else>
          <h2 class="text-2xl font-bold mb-4">Declaración de Accesibilidad</h2>
          <p class="mb-4">
            UNIVERSAL DATA SL. se ha comprometido a hacer accesible su sitio web de conformidad con el Real Decreto 1112/2018, de 7 de septiembre, sobre accesibilidad de los sitios web .
          </p>
          <p class="mb-4">
            La presente declaración de accesibilidad se aplica al sitio web: 
            <span class="font-bold underline text-secondary">{{ currentDomain }}</span>
          </p>

          <h3 class="text-xl font-semibold mb-3">Situación de cumplimiento</h3>
          <p class="mb-4">
            Este sitio web es parcialmente conforme con el RD 1112/2018 debido a las excepciones y a la falta de conformidad de los aspectos que se indican a continuación.
          </p>
          
          <h3 class="text-xl font-semibold mb-3">Contenido no accesible</h3>
          <p class="mb-2">El contenido que se recoge a continuación no es accesible por lo siguiente:</p>
          
          <h4 class="text-lg font-bold mb-2">Falta de conformidad con el RD 1112/2018</h4>
          <ul class="list-disc pl-6 mb-4 space-y-1">
            <li>Existen carencias de accesibilidad en contenido de terceros, como Google Maps.</li>
            <li>Hay enlaces en los que no se identifica correctamente su función (tienen una descripción inadecuada, un texto demasiado genérico, un title inadecuado...) [requisito número 9.2.4.4 Propósito de los enlaces, de UNE-EN 301549:2022].</li>
            <li>Podrían existir fallos puntuales de edición en alguna página web.</li>
          </ul>

          <h3 class="text-xl font-semibold mb-3">Carga desproporcionada</h3>
          <p class="mb-4">No aplica.</p>

          <h3 class="text-xl font-semibold mb-3">El contenido no entra dentro del ámbito de la legislación aplicable</h3>
          <p class="mb-4">No aplica.</p>

          <h3 class="text-xl font-semibold mb-3">Preparación de la presente declaración de accesibilidad</h3>
          <p class="mb-2">La presente declaración fue preparada el 4 de noviembre de 2025</p>
          <p class="mb-4">El método empleado para preparar la declaración ha sido una autoevaluación llevada a cabo por el propio organismo.</p>

          <h3 class="text-xl font-semibold mb-3">Observaciones y datos de contacto</h3>
          <p class="mb-2">Puede realizar comunicaciones sobre requisitos de accesibilidad (artículo 10.2.a) del RD 1112/2018 ) como por ejemplo:</p>
          <ul class="list-disc pl-6 mb-4 space-y-1">
            <li>Informar sobre cualquier posible incumplimiento por parte de este sitio web.</li>
            <li>Transmitir otras dificultades de acceso al contenido.</li>
            <li>Formular cualquier otra consulta o sugerencia de mejora relativa a la accesibilidad del sitio web.</li>
          </ul>

          <p class="mb-4 text-justify">
            Puede contactar con nosotros a través de email: 
            <a :href="`mailto:${correo}`" class="text-secondary hover:underline">{{ correo }}</a>
          </p>

          <p class="mb-2 text-justify">Puede presentar:</p>
          <ul class="list-disc pl-6 mb-4 space-y-1">
            <li>Una queja relativa al cumplimiento de los requisitos del RD 1112/2018 .</li>
            <li>Una solicitud de información accesible relativa a:
              <ul class="list-disc pl-6 mt-1 space-y-1">
                <li>Contenidos que están excluidos del ámbito de aplicación del RD 1112/2018 según lo establecido por el artículo 3, apartado 4.</li>
                <li>Contenidos que están exentos del cumplimiento de los requisitos de accesibilidad por imponer una carga desproporcionada.</li>
              </ul>
            </li>
          </ul>

          <p class="mb-4 text-justify italic border-l-4 border-secondary pl-4 py-2 bg-gray-50">
            En la solicitud de información accesible, se debe concretar, con toda claridad, los hechos, razones y petición que permitan constatar que se trata de una solicitud razonable y legítima.
          </p>

          <h3 class="text-xl font-semibold mb-3">Procedimiento de aplicación</h3>
          <p class="mb-4 text-justify">
            A través de este procedimiento podrá iniciar una reclamación para conocer y oponerse a los motivos de la desestimación de una solicitud de información accesible o queja, instar la adopción de las medidas oportunas en el caso de no estar de acuerdo con la decisión adoptada, o exponer las razones por las que se considera que la respuesta no cumple con los requisitos exigidos.
          </p>
          
          <p class="mt-8 text-sm text-gray-500 italic">
            Última actualización: Noviembre de 2025
          </p>
        </div>
      </div>
                  </v-col>
                </v-row>
                <!-- End Single Content  -->
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
  </template>
  
<script setup lang="ts">
// Plantillas 2 a 5: cabecera de página de la plantilla; el texto toma sus colores y fuentes (assets/notaria2.scss)
import N2CabezaPagina from '../components/notaria2/N2CabezaPagina.vue'
import { useDisenoPropio } from '../composables/useNotaria2'
const disenoPropio = useDisenoPropio()
import { ref, onMounted } from 'vue'
import { useStore } from '../store/index'
import { useContactoLegal } from '../composables/useContactoLegal'
import { storeToRefs } from 'pinia'

const store = useStore();
const { NOTARIA } = storeToRefs(store)
const { correo, htmlLegal } = useContactoLegal()

const currentDomain = ref(NOTARIA.value?.Ruta || '')

onMounted(() => {
  if (typeof window !== 'undefined') {
    currentDomain.value = window.location.origin
  }
})
</script>
  